import { createFileRoute } from '@tanstack/react-router';

import { Profile } from 'features/account/Profile';

export const Route = createFileRoute('/_authenticated/account/_shell/profile')({
  component: AccountProfileRoute
});

function AccountProfileRoute() {
  const { authUser } = Route.useRouteContext();

  return <Profile user={authUser.user} />;
}
